module.exports = __webpack_public_path__ + "img/BlankCard.79ca2824.jpg";